var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInputSuffix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1012_3296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.04179 8.16703H8.58095L8.41762 8.00953C9.11762 7.19286 9.47929 6.0787 9.28095 4.89453C9.00679 3.27287 7.65345 1.97786 6.02012 1.77953C3.55262 1.4762 1.47595 3.55286 1.77929 6.02036C1.97762 7.6537 3.27262 9.00703 4.89429 9.2812C6.07845 9.47953 7.19262 9.11786 8.00929 8.41786L8.16679 8.5812V9.04203L10.646 11.5212C10.8851 11.7604 11.276 11.7604 11.5151 11.5212C11.7543 11.282 11.7543 10.8912 11.5151 10.652L9.04179 8.16703ZM5.54179 8.16703C4.08929 8.16703 2.91679 6.99453 2.91679 5.54203C2.91679 4.08953 4.08929 2.91703 5.54179 2.91703C6.99429 2.91703 8.16679 4.08953 8.16679 5.54203C8.16679 6.99453 6.99429 8.16703 5.54179 8.16703Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1012_3296"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputSuffix);
export default __webpack_public_path__ + "static/media/input-suffix.e6e23334490d71330cf6915a21cee081.svg";
export { ForwardRef as ReactComponent };